import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SponsorContactService {

  // This is the set of Sponsor Contacts associated with the selected pod
  private sponsorContactsSource = new BehaviorSubject<SponsorContact[]>([]);
  currentSponsorContacts = this.sponsorContactsSource.asObservable();

  // This is a specific Sponsor Contact by sponsorContactId
  private sponsorContactSource = new BehaviorSubject<SponsorContact>(null);
  currentSponsorContact = this.sponsorContactSource.asObservable();

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  getSponsorContacts(podId: number) {
    if (podId != null) {
      this.http.get<SponsorContact[]>(`${this.baseUrl}api/sponsorContact?permitPointOfDiversionId=${podId}`)
        .subscribe(
          response => {
            this.changeSponsorContacts(response);
          },
          error => console.error(error)
        );
    }
  }

  getSponsorContact(sponsorContactId: number) {
    if (sponsorContactId != null) {
      this.http.get<SponsorContact>(`${this.baseUrl}api/sponsorContact/${sponsorContactId}`)
        .subscribe(
          response => {
            this.changeSponsorContact(response);
          },
          error => console.error(error)
        );
    }
  }

  addSponsorContact(podId: number, sponsorName: string, sponsorEmail: string) {
    if (podId == null) {
      return { success: false, failureMessage: "Point of Diversion not selected" };
    }
    var sponsorContact = {
      permitPointOfDiversionId: podId,
      name: sponsorName,
      email: sponsorEmail
    } as SponsorContact
    this.http.post(`${this.baseUrl}api/sponsorContact/`, sponsorContact, { observe: 'response' })
      .subscribe(
        response => {
          if (response) {
            //this.getSponsorContacts(podId);
          }
        },
        error => {
          return { success: false, failureMessage: error };
        }
      );
    return { success: true, failureMessage: null };
  }

  updateSponsorContact(sponsorContactId: number, sponsorName: string, sponsorEmail: string) {
    if (sponsorContactId == null) {
      return { success: false, failureMessage: "Sponsor Contact not selected" };
    }
    var sponsorContact = {
      name: sponsorName,
      email: sponsorEmail
    } as SponsorContact
    this.http.put(`${this.baseUrl}api/sponsorContact/${sponsorContactId}`, sponsorContact, { observe: 'response' })
      .subscribe(
        response => {
          if (response) {
            //this.getSponsorContact(sponsorContactId);
          }
        },
        error => {
          return { success: false, failureMessage: error };
        }
      );
    return { success: true, failureMessage: null };
  }

  deleteSponsorContact(sponsorContactId: number) {
    if (sponsorContactId == null) {
      return { success: false, failureMessage: "Sponsor Contact not selected" };
    }
    this.http.delete(`${this.baseUrl}api/sponsorContact/${sponsorContactId}`, { observe: 'response' })
      .subscribe(
        response => {
          if (response) {
            // TODO?
          }
        },
        error => {
          return { success: false, failureMessage: error };
        }
      );
    return { success: true, failureMessage: null };
  }


  changeSponsorContacts(sponsorContacts: SponsorContact[]) {
    if (sponsorContacts != null)
      this.sponsorContactsSource.next(sponsorContacts);
  }

  changeSponsorContact(sponsorContact: SponsorContact) {
    if (sponsorContact != null)
      this.sponsorContactSource.next(sponsorContact);
  }
}

export interface SponsorContact {
  sponsorContactId: number,
  permitPointOfDiversionId: number,
  name: string,
  email: string
}
